import { useState, Fragment } from 'react';
import { useMutation } from '@apollo/client/react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from 'tss-react/mui';
import { useAppContext } from '../../contexts/app';
import { updateEventMemberNotificationPreferenceMutation } from '../../apollo/events';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  button: {
    padding: theme.spacing(0, 1),
  },
}));

type Props = {
  event?: Event;
};

const EventNotificationPreferenceToggle = ({ event }: Props) => {
  const { isLoggedIn } = useAppContext();
  const [updateEventMemberNotificationPreference] = useMutation(updateEventMemberNotificationPreferenceMutation);
  const [submitting, setSubmitting] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { classes } = useStyles();

  if (!isLoggedIn || !event.membership) {
    return null;
  }

  const subscribed = event.membership.notificationPreference === 'ALL';
  const disabled = event.status !== 'PUBLISHED' || submitting;
  return (
    <Fragment>
      <Button
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
        disabled={disabled}
        aria-controls="event-notification-preference-menu"
        aria-haspopup="true"
        color="primary"
        // variant="outlined"
        className={classes.button}
      >
        {subscribed ? 'Subscribed' : 'Unsubscribed'}
      </Button>
      <Menu
        id="event-notification-preference-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setSubmitting(true);
            updateEventMemberNotificationPreference({
              variables: {
                id: event.membership.id,
                preference: subscribed ? 'NONE' : 'ALL'
              }
            }).then(() => setSubmitting(false));
          }}
        >
          {subscribed ?
            'Unsubscribe from comments' :
            'Subscribe to comments'}
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

export default EventNotificationPreferenceToggle;
